import * as React from "react";
import CustomTextInput from "../baseComponent/CustomTextInput";

export interface Props
{
    rowIndex: number;
    value: string;
    isEditing?: boolean;
    
    onChange?: (rowIndex: number, newValue: string) => void;
    onClick?: (rowIndex: number) => void;
    onDismiss?: (rowIndex: number) => void;
}



class ValueEditor extends React.Component<Props>
{
    onChange = (newValue: string) =>
    {
        if (this.props.onChange)
        {
            this.props.onChange(this.props.rowIndex, newValue);
        }
    }

    onDismiss = () =>
    {
        if (this.props.onDismiss)
        {
            this.props.onDismiss(this.props.rowIndex);
        }
    }

    onClick = () =>
    {
        if (this.props.onClick)
        {
            this.props.onClick(this.props.rowIndex);
        }
    }

    render()
    {
        return (
            <CustomTextInput 
                value={this.props.value} 
                onClick={this.onClick}
                onDismiss={this.onDismiss}
                onChange={this.onChange}
                isEditing={this.props.isEditing} />
        );
    }
}

export default ValueEditor;


// WEBPACK FOOTER //
// ./src/components/translations/ValueEditor.tsx